import type { FC } from "react";
import { useDepartmentFlags } from "../../hooks/useDepartmentFlags";
import SelfSchedulingDemo from "../SelfSchedulingDemo/SelfSchedulingDemo";
import { SelfScheduling } from "./SelfScheduling";

export const SelfSchedulingWrapper: FC = () => {
	const { isSnfDemo, isHospitalDemo } = useDepartmentFlags();
	if (isHospitalDemo || isSnfDemo) return <SelfSchedulingDemo />;

	return <SelfScheduling />;
};
